import React from 'react'
import aboutuskoffeehouse from "../images/about us _koffee.jpeg";
import Navbar from '../inc/Navbar';
import {Link} from "react-router-dom";
function Vision() {
  return (
    <div>
        <Navbar/>
          <br/>
        <br/>
        <br/>
        <br/>
          <div className='koffee'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">Vision <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

               <div className="album py-2">
        <div className="container">
          <div className="row">
            <div className="col-md-6 mt-3">
 <h1 className='mb-2 justify'>Our <b style={{color:"#3D2219"}}> VISION</b></h1>
    <p className="card-text justify">Our vision is to become the most loved and trusted family restaurant in Krishnagar and Nadia, known for quality food, excellent service, and a warm ambiance. We aim to continuously innovate our menu, uphold the highest hygiene standards, and expand our presence while keeping customer satisfaction at the heart of everything we do.</p>
   
                </div>
                  <div className="col-md-6 mt-3">
  <img src={aboutuskoffeehouse} className="card-img-top" alt="aboutuskoffeehouse"/>

                </div>
                </div>
                </div>
                
            
            </div>
            <br/>
    </div>
  )
}

export default Vision